module.exports = __webpack_public_path__ + "static/img/小米SU7.8c85c989.png";